import { BestBuyLogo, TargetLogo } from '@jouzen/ecom-components';

export default function TargetBestBuyIcons() {
  return (
    <div className="flex flex-row items-center">
      <div className="flex h-10 w-10 shrink-0 grow-0 items-center justify-center overflow-hidden rounded-full border border-gray-300 bg-sandstone-200">
        <TargetLogo className="w-6" />
      </div>
      <div className="flex h-10 w-10 shrink-0 grow-0 translate-x-[-6px] items-center justify-center overflow-hidden rounded-full border border-gray-300 bg-sandstone-200">
        <BestBuyLogo className="w-6" />
      </div>
    </div>
  );
}
